import { cloneObject  } from "../utils/utils";
import JSZip from "jszip";

import dsd from "../classes/clsDSD";

export const addDataDictionary = (dsd, Data = {}, onAdd, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadDataDictionary(Data)

    dsd.httpConfig.post(`/datadictionaries`, payload, headers)
        .then(response => {
            if (onAdd){
                onAdd(response.data._id)
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return;
}

export const editDataDictionary = (dsd, id = null, Data = {}, onUpdate, onError) => {
    
    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }


    let payload = payloadDataDictionary(Data)

    dsd.httpConfig.put(`/datadictionaries/${id}`, payload, headers)
        .then(response => {
            if (onUpdate){
                onUpdate();
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return true;
};

function payloadDataDictionary(data){

    let payload = {}
    payload.name = data.name;
    payload.description = data.description;
    payload.namespace = data.namespace;
    payload.prefix = data.prefix;
    payload.proposals = data.proposals;
    payload.status = data.status;

    return payload;

}


export const listDataDictionaries = (dsd, Filters={}, onLoad, onError) => {
    
    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let urlAPI = "/datadictionaries"
    if (Object.keys(Filters).length > 0){
        urlAPI += "?"
    }
    
    if (Filters.idUser){
        urlAPI += `idUser=${encodeURIComponent(Filters.idUser)}&`;
    }

    if (Filters.scope){
        urlAPI += `scope=${encodeURIComponent(Filters.scope)}&`;
    }

    if (Filters.status){
        urlAPI += `status=${encodeURIComponent(Filters.status)}&`;
    }

    if (Filters.search){
        urlAPI += `search=${encodeURIComponent(Filters.search)}&`;
    }
    
    dsd.httpConfig.get(urlAPI, headers)
        .then(response => {

            let arr = [];
            for (let pos=0; pos<response.data.length;pos++){
                arr.push(dataDataDictionary(response.data[pos]));
            }
            if (onLoad){
                onLoad(arr);
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return;

};

export const getDataDictionary = (dsd, id=null, onLoad=null, onFail=null, representation="dsd", format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/datadictionaries/${id}?`

        if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};

export const getDataDictionaryVersion = (dsd, id=null, idVersion = null, onLoad=null, onFail=null, representation='dsd', format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/datadictionaries/${id}/version/${idVersion}?`

    if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};

export const getDataDictionaryVersionStructures = (dsd, id=null, idVersion = null, onLoad=null, onFail=null, representation='dsd', format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/datadictionaries/${id}/version/${idVersion}/structures?`

    if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};

function dataDataDictionary(data){

    let obj = data;

    return obj;

}




export const getEnumeration = (dsd, id=null, onLoad=null, onFail=null, representation="dsd", format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/enumerations/${id}?`

        if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};

function dataEnumeration(data){

    let obj = data;

    return obj;

}


export const addEnumerationToDataDictionary = (dsd, idDataDictionary, Data = {}, onAdd, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadEnumeration(Data)

    dsd.httpConfig.post(`/datadictionaries/${idDataDictionary}/enumerations`, payload, headers)
        .then(response => {
            if (onAdd){
                onAdd(response.data._id)
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });
}
    
    
export const editEnumeration = (dsd, id = null, Data = {}, onUpdate, onError) => {
    
    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }


    let payload = payloadEnumeration(Data)
    let idDataDictionary = null;
    if (Data.DataDictionary) {
        idDataDictionary = Data.DataDictionary._id;
    }

    dsd.httpConfig.put(`/datadictionaries/${idDataDictionary}/enumerations/${id}`, payload, headers)
        .then(response => {
            if (onUpdate){
                onUpdate();
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });
};
    
export const deleteEnumeration = (dsd, idDataDictionary, id, onDelete, onError) => {
    
    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    dsd.httpConfig.delete(`/datadictionaries/${idDataDictionary}/enumerations/${id}`, headers)
        .then(response => {
            if (onDelete){
                onDelete();
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return true;

}
    
    
function payloadEnumeration(inData){
    
    let data = cloneObject(inData)

    let payload = {}
    payload.name = data.name;

    payload.description = data.description;

    payload.namespace = data.namespace;
    payload.prefix = data.prefix;

    payload.notes = data.notes;
    payload.proposals = data.proposals;

    payload.idStructure = null;
    if (data.idStructure){
        payload.idStructure = data.idStructure;
    }

    payload.status = data.status;

    payload.Terms = [];
    if (Array.isArray(payload.Terms)){
        payload.Terms = data.Terms;
    }

    return payload;

}
    

    
export const listEnumerations = (dsd, Filters={}, onLoad, onError) => {
    
    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let urlAPI = "/enumerations"
    if (Object.keys(Filters).length > 0){
        urlAPI += "?"
    }
    
    if (Filters.idUser)  { urlAPI += `idUser=${encodeURIComponent(Filters.idUser)}&`; }
    if (Filters.status)  { urlAPI += `status=${encodeURIComponent(Filters.status)}&`; }
    if (Filters.search)  { urlAPI += `search=${encodeURIComponent(Filters.search)}&`; }
    if (Filters.idDataDictionary)  { urlAPI += `idDataDictionary=${encodeURIComponent(Filters.idDataDictionary)}&`; }


    
    dsd.httpConfig.get(urlAPI, headers)
        .then(response => {

            let arr = [];
            for (let pos=0; pos<response.data.length;pos++){
                arr.push(dataEnumeration(response.data[pos]));
            }
            if (onLoad){
                onLoad(arr);
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return;

};



export const zipDataDictionary = async function(dsd, id, idVersion){

    const zip = new JSZip();

    const assets = await assetsDataDictionaryVersion(dsd, id, idVersion);

    const DataDictionary = assets["dsd.json"];

    let nameFolder = `datadictionary_${id}`;
    if (idVersion){
        nameFolder += `_version_${idVersion}`;
    }

    for (const idAsset in assets){
        let assetValue = assets[idAsset];

        // Serialize JSON-like objects before zipping.
        if (
            typeof assetValue === 'object' &&
            assetValue !== null &&
            !(assetValue instanceof Blob) &&
            !(assetValue instanceof ArrayBuffer) &&
            !(assetValue instanceof Uint8Array)
        ) {
            assetValue = JSON.stringify(assetValue, null, 4);
        }

        zip.file(`${nameFolder}/${idAsset}`, assetValue);

// repeat for /site and /siteGDS

        if (idAsset.startsWith("site/") || idAsset.startsWith("siteGDS/")) {
            continue;
        }

        switch (idAsset) {
            case "page.md":
            case "index.html":
            case "indexGDS.html":
                break; // Skip these files for /site and /siteGDS
            default:{
                zip.file(`${nameFolder}/site/${idAsset}`, assetValue);
                zip.file(`${nameFolder}/siteGDS/${idAsset}`, assetValue);
            }
        }
    }

    const zipData = await zip.generateAsync({
        type: "blob",
        streamFiles: true,
    });

    return zipData;

};

export const assetsDataDictionaryVersion = async function(dsd, idDataDictionary, idVersion){

    const assets = {};

    let Promises = [];

    let doc = null;
    let page = null;
    let index = null;
    let indexGDS = null;

    let site = null;
    let siteGDS = null;


    let csv = null;
    let rdfs = null;
    let skos = null;
    let xsds = null;
    let dotStructures = null;
    let svg = null;
    let svgStructures = null;

    let DataDictionary = null
    
    const onDoneDoc = function(reply){
        doc = reply;
        return;
    };


    const onDonePage = function(reply){
        page = reply;
        return;
    };


    const onDoneIndex = function(reply){
        index = reply;
        return;
    };

    const onDoneIndexGDS = function(reply){
        indexGDS = reply;
        return;
    };


    const onDoneSite = function(reply){
        site = reply;
        return;
    };

    const onDoneSiteGDS = function(reply){
        siteGDS = reply;
        return;
    };


    const onDoneCsv = function(reply){
        csv = reply;
        return;
    };

    const onDoneRdfs = function(reply){
        rdfs = reply;
        return;
    };

    const onDoneSkos = function(reply){
        skos = reply;
        return;
    };

    const onDoneXsd = function(reply){
        xsds = reply;
        return;
    };

    const onDoneDotStructures = function(reply){
        dotStructures = reply;
        return;
    };

    const onDoneSvg = function(reply){
        svg = reply;
        return;
    };

    const onDoneSvgStructures = function(reply){
        svgStructures = reply;
        return;
    };


    Promises.push(getDataDictionaryVersion(dsd,idDataDictionary,idVersion, onDoneDoc));
    
    Promises.push(getDataDictionaryVersion(dsd,idDataDictionary,idVersion, onDonePage, null,'page'));
    Promises.push(getDataDictionaryVersion(dsd,idDataDictionary,idVersion, onDoneIndex, null,'page', 'html'));

    Promises.push(getDataDictionaryVersion(dsd,idDataDictionary,idVersion, onDoneIndexGDS, null,'page', 'html',{style:'UK Government Design System'}));

    Promises.push(getDataDictionaryVersion(dsd,idDataDictionary,idVersion, onDoneSite, null,'site', 'json'));
    Promises.push(getDataDictionaryVersion(dsd,idDataDictionary,idVersion, onDoneSiteGDS, null,'site', 'json',{style:'UK Government Design System'}));

    Promises.push(getDataDictionaryVersion(dsd, idDataDictionary, idVersion, onDoneCsv, null, 'csv'));
    Promises.push(getDataDictionaryVersion(dsd, idDataDictionary, idVersion, onDoneCsv, null, 'csv'));
    Promises.push(getDataDictionaryVersion(dsd, idDataDictionary, idVersion, onDoneRdfs, null, 'rdfs'));
    Promises.push(getDataDictionaryVersion(dsd, idDataDictionary, idVersion, onDoneSkos, null, 'skos'));
    Promises.push(getDataDictionaryVersion(dsd, idDataDictionary, idVersion, onDoneXsd, null, 'xsd'));
    Promises.push(getDataDictionaryVersionStructures(dsd, idDataDictionary, idVersion, onDoneDotStructures, null, 'dot'));
    Promises.push(getDataDictionaryVersionStructures(dsd, idDataDictionary, idVersion, onDoneSvgStructures, null, 'image'));
    

    return(
        Promise.all(Promises)
        .then(async response => {

            if (doc){
                assets["dsd.json"] = doc;
                DataDictionary = cloneObject(doc);
            }

            if (page){
                assets["page.md"] = page;
            }
            if (index){
                assets["index.html"] = index;
            }
            
            if (indexGDS){
                assets["indexGDS.html"] = indexGDS;
            }


            if (csv){
                assets["datadictionary.csv"] = csv;
            }
            if (rdfs){
                assets["datadictionary.ttl"] = rdfs;
            }
            if (skos){
                assets["skos.ttl"] = skos;
            }
            if (xsds && typeof xsds === 'object'){
                // XSD format returns multiple files as object {filename: content}
                for (let filename in xsds){
                    assets[`${filename}`] = xsds[filename];
                }
            }

            if (svgStructures){
                if (DataDictionary){
                    if (DataDictionary.Structures){
                        for (let Structure of DataDictionary.Structures){
                            if (Structure._id in svgStructures){
                                assets[`structures/${Structure._id}/image.svg`] = svgStructures[Structure._id];
                            }
                        }
                    }
                }
            }

            if (dotStructures){
                if (DataDictionary){
                    if (DataDictionary.Structures){
                        for (let Structure of DataDictionary.Structures){
                            if (Structure._id in dotStructures){
                                assets[`structures/${Structure._id}/image.dot`] = dotStructures[Structure._id];
                            }
                        }
                    }
                }
            }


            if (site && site.files){
                for (const file of site.files){
                    if (file.content != null){
                        assets[`site/${file.path}`] = file.content;
                    }
                }
            }

            if (siteGDS && siteGDS.files){
                for (const file of siteGDS.files){
                    if (file.content != null){
                        assets[`siteGDS/${file.path}`] = file.content;
                    }
                }
            }

            return assets;    

        })
    );

};



// ========== Structure Utility Functions ==========

// Helper function to prepare Structure payload
const payloadStructure = (data) => {
    let Structure = {};

    // Structure fields
    if (data.name !== undefined) Structure.name = data.name;
    if (data.description !== undefined) Structure.description = data.description;
    if (data.proposals !== undefined) Structure.proposals = data.proposals;
    if (data.status !== undefined) Structure.status = data.status;

    // Arrays
    Structure.Concepts = [];
    if (data.Concepts) Structure.Concepts = data.Concepts;
    
    Structure.Attributes = [];
    if (data.Attributes) Structure.Attributes = data.Attributes;

    return Structure;
};

// Helper function to process Structure data
const dataStructure = (data) => {
    return data;
};

const dataStructureAttribute = (data) => {
    return data;
};


// Add Structure to DataDictionary
export const addStructure = (dsd, idDataDictionary, Data, onAdd, onError) => {
    
    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader) {
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadStructure(Data);

    dsd.httpConfig.post(`/datadictionaries/${idDataDictionary}/structures`, payload, headers)
        .then(response => {
            if (onAdd){
                onAdd(response.data._id)
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });
};

// Edit existing Structure
export const editStructure = (dsd, id, Data, onUpdate, onError) => {
    
    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader) {
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadStructure(Data);

    let idDataDictionary = null;
    if (Data.DataDictionary) {
        idDataDictionary = Data.DataDictionary._id;
    }

    dsd.httpConfig.put(`/datadictionaries/${idDataDictionary}/structures/${id}`, payload, headers)
        .then(response => {
            if (onUpdate){
                onUpdate();
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });
};

// Get single Structure
export const getStructure = (dsd, id=null, onLoad=null, onFail=null, representation="dsd", format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/structures/${id}?`

        if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};

// List Structures
export const listStructures = (dsd, Filters={}, onLoad, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let urlAPI = "/structures"
    if (Object.keys(Filters).length > 0){
        urlAPI += "?"
    }

    if (Filters.idUser)  { urlAPI += `idUser=${encodeURIComponent(Filters.idUser)}&`; }
    if (Filters.status)  { urlAPI += `status=${encodeURIComponent(Filters.status)}&`; }
    if (Filters.search)  { urlAPI += `search=${encodeURIComponent(Filters.search)}&`; }
    if (Filters.idDataDictionary)  { urlAPI += `idDataDictionary=${encodeURIComponent(Filters.idDataDictionary)}&`; }
    if (Filters.idSubStructure)  { urlAPI += `idSubStructure=${encodeURIComponent(Filters.idSubStructure)}&`; }
    if (Filters.idNarrative)  { urlAPI += `idNarrative=${encodeURIComponent(Filters.idNarrative)}&`; }

    dsd.httpConfig.get(urlAPI, headers)
        .then(response => {
            let arr = [];
            for (let pos=0; pos<response.data.length;pos++){
                arr.push(dataStructure(response.data[pos]));
            }
            if (onLoad){
                onLoad(arr);
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return;
};



export const listStructureAttributes = (dsd, Filters={}, onLoad, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let urlAPI = "/structureattributes"
    if (Object.keys(Filters).length > 0){
        urlAPI += "?"
    }
    
    if (Filters.idUser){
        urlAPI += `idUser=${encodeURIComponent(Filters.idUser)}&`;
    }

    if (Filters.status){
        urlAPI += `status=${encodeURIComponent(Filters.status)}&`;
    }

    if (Filters.idStructure){
        urlAPI += `idStructure=${encodeURIComponent(Filters.idStructure)}&`;
    }

    if (Filters.usesIdStructure){
        urlAPI += `usesIdStructure=${encodeURIComponent(Filters.usesIdStructure)}&`;
    }


    dsd.httpConfig.get(urlAPI, headers)
        .then(response => {
            let arr = [];
            for (let pos=0; pos<response.data.length;pos++){
                arr.push(dataStructureAttribute(response.data[pos]));
            }
            if (onLoad){
                onLoad(arr);
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return;
};



export const getStructures = (Structure, listStructures = {}) => {
    if (Structure){
        listStructures[Structure._id] = Structure;
        if (Structure.Attributes){
            for (let posA=0;posA<Structure.Attributes.length;posA++){
                let Attribute = Structure.Attributes[posA];
                if (Attribute.Structure){
                    getStructures(Attribute.Structure,listStructures);
                }
            }
        }
    }

    return listStructures;
};